<template>
  <div id>
    <v-dialog v-model="show_error_dialog" :width="350">
      <v-card>
        <v-card-title>
          {{dialog_title}}
          <v-spacer></v-spacer>
          <v-btn icon @click="show_error_dialog=false">
            <v-icon>fa fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>{{dialog_error}}</v-card-text>
        <v-card-actions class="grey lighten-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" to="/user/profile#section-3">My Profile</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="success_dialog" width="350">
      <v-card>
        <v-card-title>Project Submitted</v-card-title>
        <v-card-text>
          Your project was successfully submitted
          <br />We will review it shortly
        </v-card-text>
        <v-card-actions class="grey lighten-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" to="/user/projects">My Projects</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-if="($store.state.app.display ==='xs' || $store.state.app.display ==='sm')">
      <v-container
        class="white lighten-3 px-4 py-4 bottomnav"
        fluid
        style="position:fixed;bottom:0px;left:0px;right:0px;z-index:100"
      >
        <v-row justify="space-around" align="center">
          <div v-for="(button,i) in menu_buttons" :key="i">
            <v-badge overlap color="red" v-if="button.badge">
              <template v-slot:badge>{{button.badge}}</template>
              <v-btn
                icon
                :color="button.color"
                @click="button.click ? button.click() : null"
                :to="button.to ? button.to : null"
              >
                <v-icon>{{button.icon}}</v-icon>
              </v-btn>
            </v-badge>
            <v-btn
              v-else
              icon
              :color="button.color"
              @click="button.click ? button.click() : null"
              :to="button.to ? button.to : null"
              :disabled="button.disabled"
              :loading="button.loading"
            >
              <div
                :class="button.rank ? `rank-star rank-${$store.state.account.account.rank}-star` : ``"
              >
                <v-icon :large="button.large ? true : false">{{button.icon}}</v-icon>
              </div>
            </v-btn>
          </div>
        </v-row>
      </v-container>
    </div>

    <v-card-actions class="secondary white--text" v-if="project.contest">
      <v-col cols="3">
        <v-icon dark>fa-gift</v-icon>
      </v-col>
      <v-col cols="6" class="text-center">
        <h3>Contest Entry</h3>
      </v-col>
      <v-col cols="3" class="text-right">
        <v-btn
          icon
          dark
          @click="$eventBus.$emit('play_video',$store.state.app.tutorials.project_create['Contest'])"
        >
          <v-icon>fa-question</v-icon>
        </v-btn>
      </v-col>
    </v-card-actions>
    <v-card-actions class="cool_purple white--text" v-if="project.contest">
      <v-col cols="12" class="pt-0 pb-2 text-center">
        <router-link
          class="nolink white--text"
          :to="`/contests/${project.contest.id}/${project.contest.slug}`"
        >
          <h5>{{project.contest.title}}</h5>
        </router-link>
      </v-col>
    </v-card-actions>

    <v-container>
      <v-row class justify="center">
        <v-col cols="12" md="10" lg="8" xl="6">
          <v-row class="py-0" v-if="project.id" id="project-status">
            <v-col cols="12" class="py-2">
              <v-alert
                outlined
                dark
                border="left"
                :icon="$store.getters['user_projects/statusIcon'](project)"
                :color="$store.getters['user_projects/statusColor'](project)"
              >
                <h5>{{project.status==13 ? "Why was my project rejected?" : $store.getters['user_projects/statusLabel'](project)}}</h5>
                <v-divider></v-divider>
                <v-row align="center" v-for="(revision,i) in revisions" :key="i">
                  <v-col cols="4" md="2" class v-if="revision.video">
                    <v-btn
                      :color="project.status===13 ? 'red' :'warning'"
                      outlined
                      class
                      x-large
                      :height="81"
                      @click="$eventBus.$emit('play_video',revision.video)"
                    >
                      <div class="mt-2">
                        <v-icon large dark>fa-play</v-icon>
                        <br />
                        <span class="caption secondary--text">Message</span>
                      </div>
                    </v-btn>
                  </v-col>
                  <v-col cols="8" md="7" class="pr-1 secondary--text">
                    <div>
                      <h5>Message from editor</h5>
                      <p class="mb-0">{{revision.note}}</p>
                    </div>
                  </v-col>
                </v-row>
              </v-alert>
            </v-col>
          </v-row>
          <v-row align="center" class="py-0" v-if="project.id">
            <v-col cols="12" class="py-2">
              <v-text-field
                color="secondary"
                @change="updateTitle"
                hide-details
                :readonly="!canEditTitle"
                :rules="[$helpers.rules.required]"
                outlined
                v-model="project.title"
                label="What are you talking about today ?"
                :clearable="canEditTitle"
              ></v-text-field>
            </v-col>
          </v-row>

            <v-row v-if="project.report" class="mb-4">
          <v-col cols="12">
            <v-card>
              <v-card-title class="secondary white--text">
                <h5>Quality card</h5>
              </v-card-title>
    <v-simple-table>
                <template v-slot:default>
                                <thead>
                                <tr>
                                <th class="text-left">
                                <v-btn text color="secondary" v-if="project.report.congrats_video"  @click="$eventBus.$emit('play_video',project.report.congrats_video)">
                                  <v-icon small color="primary" class="mr-2" >fa-play</v-icon>
                                  <span v-if="project.status===13">Video</span>
                                  <span v-if="project.status===11">Congrats</span>
                                </v-btn>
                                </th>
                                <th v-for="n in 10" :key="n" style="min-width:120px" :class="`text-center white--text rank-${n}-bg`">Rank {{n}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(category,i,k) in project.report.score" :key="k">
                                <td class="caption" style="min-width:120px;">
                                {{categories[i].label}}
                                </td>
                                <td v-for="n in 10" :key="n" style="min-width:120px;border-left:1px solid rgba(0, 0, 0, 0.12)" :class="`text-center ${category[n - 1] ? '' : 'secondary lighten-3'}`">


                                <div v-if="category[n - 1]">
                                 <span :class="`rank-star rank-${n}-star`">
                                   <v-icon small v-if="category[n-1].reduce((c,j)=>c+j, 0) == category[n-1].length">fas fa-star</v-icon>
                                    <v-icon small v-else>far fa-star</v-icon>
                                 </span>
                                 <v-menu open-on-hover top offset-y v-for="(goal,goal_i) in category[n-1]" :key="goal_i">
                                   <template v-slot:activator="{ on }">
                                 <v-btn small icon v-on="on" >
                                   <v-icon small color="green" v-if="goal">far fa-check-square</v-icon>
                                    <v-icon small color="red" v-if="!goal">far fa-square</v-icon>
                                 </v-btn>
                                   </template>
                <v-card>
                  <v-card-text>
                    <p class="mb-0">
                      {{categories[i].goals[n-1][goal_i]}}
                    </p>
                  </v-card-text>
                </v-card>
                </v-menu>
</div>

<div v-else :class="`text-center`">
  <v-tooltip bottom v-if="k==4">
    <template v-slot:activator="{ on }">
                                      <v-icon v-on="on" x-large dark>fa-lock</v-icon>
                                      </template>
    <span>This rank is locked</span>
  </v-tooltip>
  <v-icon v-else>fa-blank</v-icon>
</div>

</td>

</tr>
</tbody>
<tfoot>
  <tr style="border-top: 1px solid rgba(0, 0, 0, 0.12);">
    <th class="text-left">Total</th>
    <th v-for="n in 10" :key="n" style="min-width:120px" :class="`text-center white--text rank-${n}-bg`">
      <span v-if="project.report.stars[n-1]">{{project.report.stars[n-1]}} / 10</span>
    </th>
  </tr>
</tfoot>
</template>
</v-simple-table>
              </v-card>
              </v-col>
              </v-row>

          <v-row justify="space-around" v-if="[1,5].includes(project.status)">
            <v-radio-group color="primary" v-model="upload_type" row>
              <v-radio color="primary" label="Raw clips" :value="1"></v-radio>
              <v-radio color="primary" label="Complete video" :value="2"></v-radio>
            </v-radio-group>
          </v-row>

          <v-row class justify="center" v-if="upload_type==2">
            <v-col cols="12" id="section-5">
              <videos-upload
                :single="true"
                @video="uploadVideo"
                :revisions="section_5.revisions"
                @delete="deleteVideo"
                :videos="section_5.videos"
                :uploads="section_5.uploads"
                :can_upload="canAddVideos"
                :can_delete="canDeleteVideos"
                title="Complete video"
                icon="fa-film"
                :section="5"
                :tutorial="$store.state.app.tutorials.project_create['Intro & Outro']"
              ></videos-upload>
            </v-col>
          </v-row>

          <v-row class justify="center" v-else>
            <v-col cols="12" id="section-1">
              <videos-upload
                @video="uploadVideo"
                :revisions="section_1.revisions"
                @delete="deleteVideo"
                :videos="section_1.videos"
                :uploads="section_1.uploads"
                :can_upload="canAddVideos"
                :can_delete="canDeleteVideos"
                title="Intro &amp; Outro"
                icon="far fa-laugh"
                :section="1"
                :tutorial="$store.state.app.tutorials.project_create['Intro & Outro']"
              ></videos-upload>
            </v-col>
            <v-col cols="12" id="section-2">
              <videos-upload
                @video="uploadVideo"
                :revisions="section_2.revisions"
                @delete="deleteVideo"
                :videos="section_2.videos"
                :uploads="section_2.uploads"
                :can_upload="canAddVideos"
                :can_delete="canDeleteVideos"
                title="The Story"
                icon="fa-history"
                :section="2"
                :tutorial="$store.state.app.tutorials.project_create['The Story']"
              ></videos-upload>
            </v-col>
            <v-col cols="12" id="section-3">
              <videos-upload
                @video="uploadVideo"
                :revisions="section_3.revisions"
                @delete="deleteVideo"
                :videos="section_3.videos"
                :uploads="section_3.uploads"
                :can_upload="canAddVideos"
                :can_delete="canDeleteVideos"
                title="Key Features"
                icon="fa-key"
                :section="3"
                :tutorial="$store.state.app.tutorials.project_create['Key Features']"
              ></videos-upload>
            </v-col>
            <v-col cols="12" id="section-4">
              <videos-upload
                @video="uploadVideo"
                :revisions="section_4.revisions"
                @delete="deleteVideo"
                :videos="section_4.videos"
                :uploads="section_4.uploads"
                :can_upload="canAddVideos"
                :can_delete="canDeleteVideos"
                title="Favourite Thing"
                icon="fa-child"
                :section="4"
                :tutorial="$store.state.app.tutorials.project_create['Favourite Thing']"
              ></videos-upload>
            </v-col>
          </v-row>

          <div class v-if="canSubmit && showAgreements">
            <v-form ref="agreement-form">
              <v-row v-if="project.contest" justify="center">
                <v-col cols="12" class="py-0">
                  <v-checkbox
                    :label="$store.state.app.project_agreements.contest[0]"
                    v-model="agree[0]"
                    color="primary"
                    :rules="[rules.check]"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-checkbox
                    :label="$store.state.app.project_agreements.contest[1]"
                    v-model="agree[1]"
                    color="primary"
                    :rules="[rules.check]"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-checkbox
                    :label="$store.state.app.project_agreements.contest[2]"
                    v-model="agree[2]"
                    color="primary"
                    :rules="[rules.check]"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-checkbox
                    :label="$store.state.app.project_agreements.contest[3]"
                    v-model="agree[3]"
                    color="primary"
                    :rules="[rules.check]"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row v-else justify="center">
                <v-col cols="12" class="py-0">
                  <v-checkbox
                    :label="$store.state.app.project_agreements.project[0]"
                    v-model="agree[0]"
                    color="primary"
                    :rules="[rules.check]"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-checkbox
                    :label="$store.state.app.project_agreements.project[1]"
                    v-model="agree[1]"
                    color="primary"
                    :rules="[rules.check]"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-checkbox
                    :label="$store.state.app.project_agreements.project[2]"
                    v-model="agree[2]"
                    color="primary"
                    :rules="[rules.check]"
                  ></v-checkbox>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-checkbox
                    :label="$store.state.app.project_agreements.project[3]"
                    v-model="agree[3]"
                    color="primary"
                    :rules="[rules.check]"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </v-form>
          </div>

          <v-row v-if="error" id="error" class="py-0">
            <v-col cols="12" class="py-0">
              <v-alert type="error">{{error}}</v-alert>
            </v-col>
          </v-row>

          <v-row justify="space-between" class="mt-4">
            <v-col cols="12" md="6" class="text-center text-md-left">
              <v-btn
                id="delete-btn"
                large
                v-if="[1,13].includes(project.status)"
                @click="deleteProject"
                rounded
                color="red"
                :loading="uploading || loading"
                dark
                class="mr-4"
              >
                Delete
                <v-icon class="ml-2">fa-trash</v-icon>
              </v-btn>
            </v-col>
            <v-col
              cols="12"
              md="6"
              class="text-right"
              v-if="($store.state.app.display !=='xs' && $store.state.app.display !=='sm')"
            >
              <v-btn
                id="save-btn"
                large
                @click="submitProject"
                v-if="canSubmit"
                rounded
                color="green"
                :loading="uploading || loading"
                dark
              >
                Submit
                <v-icon class="ml-2">fa-arrow-circle-up</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import videos from "@/components/project_create/videos";
import Axios from "axios";

export default {
  name: "",
  data: () => ({
    upload_type: 1,
    loading: false,
    error: null,
    dialog_error: false,
    dialog_title: "",
    show_error_dialog: false,
    success_dialog: false,
    agree: [false, false, false, false],
    project: {
      report: null,
      videos: [],
      contest: null,
      title: "",
    },
    uploads: [],
  }),
  components: {
    videosUpload: videos,
  },
  created() {},
  computed: {
    showAgreements() {
      return this.project.status === 1;
    },
    categories() {
      return this.$store.state.app.project_report_categories;
    },
    rules() {
      return this.$helpers.rules;
    },
    canEditTitle() {
      if (this.project.status === 1 || this.project.status === 5) {
        return true;
      }
      return false;
    },
    canAddVideos() {
      if (this.project.status === 1 || this.project.status === 5) {
        return true;
      }
      return false;
    },
    canDeleteVideos() {
      if (this.project.status === 1) {
        return true;
      }
      return false;
    },
    menu_buttons() {
      return [
        {
          color: "secondary",
          to: "/contests",
          icon: "fa-gift",
        },
        {
          color: "secondary",
          to: "/user/progress",
          icon: "fa-star",
          rank: true,
        },
        {
          color: "green",
          icon: "fa-arrow-circle-up",
          click: this.submitProject,
          disabled: this.canSubmit ? false : true,
          large: true,
          loading: this.uploading || this.loading,
        },
        {
          color: "secondary",
          badge: this.$store.getters["notifications/count"],
          icon: "fa-bell",
          click: this.showNotifications,
        },
        {
          color: "secondary",
          icon: "fa-user",
          to: "/user/profile",
        },
      ];
    },
    uploading() {
      return this.uploads.length ? true : false;
    },
    canSubmit() {
      if (![1, 5].includes(this.project.status)) {
        return false;
      }
      return true;
    },
    revisions() {
      if ([5, 13].includes(this.project.status)) {
        return this.project.revisions.filter((r) => {
          return !r.section;
        });
      } else {
        return [];
      }
    },
    section_1() {
      return {
        videos: this.project.videos.filter((v) => {
          return v.section === 1;
        }),
        uploads: this.uploads.filter((v) => {
          return v.section === 1;
        }),
        revisions:
          this.project.status === 5
            ? this.project.revisions.filter((r) => {
                return r.section === 1;
              })
            : [],
      };
    },
    section_2() {
      return {
        videos: this.project.videos.filter((v) => {
          return v.section === 2;
        }),
        uploads: this.uploads.filter((v) => {
          return v.section === 2;
        }),
        revisions:
          this.project.status === 5
            ? this.project.revisions.filter((r) => {
                return r.section === 2;
              })
            : [],
      };
    },
    section_3() {
      return {
        videos: this.project.videos.filter((v) => {
          return v.section === 3;
        }),
        uploads: this.uploads.filter((v) => {
          return v.section === 3;
        }),
        revisions:
          this.project.status === 5
            ? this.project.revisions.filter((r) => {
                return r.section === 3;
              })
            : [],
      };
    },
    section_4() {
      return {
        videos: this.project.videos.filter((v) => {
          return v.section === 4;
        }),
        uploads: this.uploads.filter((v) => {
          return v.section === 4;
        }),
        revisions:
          this.project.status === 5
            ? this.project.revisions.filter((r) => {
                return r.section === 4;
              })
            : [],
      };
    },
    section_5() {
      return {
        videos: this.project.videos.filter((v) => {
          return v.section === 5;
        }),
        uploads: this.uploads.filter((v) => {
          return v.section === 5;
        }),
        revisions:
          this.project.status === 5
            ? this.project.revisions.filter((r) => {
                return r.section === 5;
              })
            : [],
      };
    },
  },
  methods: {
    async canUserCreateProject() {
      let profile_videos = await this.$api({
        method: "GET",
        url: `/account/user/profile-videos`,
      });
      let valid_thank_you_video = profile_videos.find((v) => {
        return v.section === 3;
      });
      if (!valid_thank_you_video) {
        this.dialog_title = this.$store.state.app.project_requirements.video_required.title; //'Just one thing'
        this.dialog_error = this.$store.state.app.project_requirements.video_required.description; //'You must have a published thank you video to create a project'
        this.show_error_dialog = true;
        return false;
      }
      if (valid_thank_you_video.approved !== 1) {
        this.dialog_title = this.$store.state.app.project_requirements.video_review.title; //'Almost there'
        this.dialog_error = this.$store.state.app.project_requirements.video_review.description; //'Waiting on publishing team… in the meantime ensure all your wallet and setting info is updated and current and other things like links/resume/other videos (work experience) are completed… blah blah'
        this.show_error_dialog = true;
        return false;
      }
      return true;
    },
    async loadProject() {
      let id = this.$route.params.id;
      this.loading = true;
      try {
        this.project = await this.$api({
          method: "GET",
          url: `/account/user/projects/${id}`,
        });

        if (
          this.project.videos.find((i) => {
            return i.section == 5;
          })
        ) {
          this.upload_type = 2;
        }
      } catch (ex) {
        this.$router.push(`/user/projects`);
      }

      this.loading = false;
    },
    showNotifications() {
      this.$eventBus.$emit("show_notifications");
    },
    async updateTitle() {
      this.loading = true;
      try {
        await this.$api({
          method: "POST",
          url: `/account/user/projects/${this.project.id}`,
          data: {
            title: this.project.title,
          },
        });
      } catch (ex) {
        this.error = ex.error;
      }

      this.loading = false;
    },
    async deleteProject() {
      if (!confirm("Are you sure you want to delete this project ?")) {
        return;
      }
      this.loading = true;
      try {
        await this.$api({
          method: "DELETE",
          url: `/account/user/projects/${this.project.id}`,
        });
        this.$router.push(`/user/projects`);
      } catch (ex) {
        this.error = ex.error;
        this.scrollToError();
      }
      this.loading = false;
    },
    async submitProject() {
      if (!this.section_5.videos.length) {
        if (
          !this.section_1.videos.length ||
          !this.section_2.videos.length ||
          !this.section_3.videos.length ||
          !this.section_4.videos.length
        ) {
          this.error = "Please upload videos for all sections.";
          this.scrollToError();
          return false;
        }
      }

      if (!this.project.title) {
        this.error = "Project title required";
      }

      if (this.showAgreements) {
        if (!this.$refs["agreement-form"].validate()) {
          return;
        }
        let agree_all = true;
        this.agree.forEach((a) => {
          if (!a) {
            agree_all = false;
          }
        });
        if (!agree_all) {
          this.error = "Agreements required";
          this.scrollToError();
          return false;
        }
      }

      try {
        this.loading = true;

        // let canSubmit = await this.canUserCreateProject();
        // if (!canSubmit) {
        //   this.loading = false;
        //   return;
        // }

        await this.$api(`/account/user/projects/${this.project.id}/submit`);
        await this.loadProject();
        this.scrollToStatus();
        this.success_dialog = true;
      } catch (ex) {
        this.error = ex.error;
        this.scrollToError();
      }
      this.loading = false;
    },

    async uploadVideo(options) {
      this.error = null;
      let upload = {
        section: options.section,
        file: options.file,
        progress: 0,
      };
      this.uploads.push(upload);
      try {
        let upload_url = await this.$api({
          method: "POST",
          url: `/account/upload-url`,
          data: {
            file: {
              name: options.file.name,
              size: options.file.size,
              type: options.file.type,
            },
            key: `project-videos/${this.project.uid}/${options.section}`,
          },
        });
        var upload_options = {
          headers: {
            "Content-Type": options.file.type,
            "x-amz-acl": "public-read",
          },
          Metadata: {
            "Content-Disposition": "attachment",
          },
          onUploadProgress: function (progressEvent) {
            upload.progress = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          }.bind(this),
        };
        await Axios.put(upload_url, options.file, upload_options);

        await this.addVideo({
          url: upload_url.split("?")[0],
          file_name: options.file.name,
          file_size: options.file.size,
          section: options.section,
          is_revision: this.project.status === 5 ? 1 : 0,
        });
      } catch (ex) {
        alert("Error uploading video, please try again");
      }

      this.deleteUpload(upload);
    },
    async addVideo(video) {
      let added_videos = await this.$api({
        method: "POST",
        url: `/account/user/projects/${this.project.id}/add-videos`,
        data: {
          videos: [video],
        },
      });
      added_videos.forEach((v) => {
        this.project.videos.push(v);
      });
    },
    async deleteVideo(video) {
      if (!confirm("Delete video ?")) {
        return;
      }
      await this.$api({
        method: "DELETE",
        url: `/account/user/projects/${this.project.id}/delete-video/${video.id}`,
      });

      this.project.videos = this.project.videos.filter((v) => {
        return v !== video;
      });
    },
    deleteUpload(upload) {
      this.uploads = this.uploads.filter((v) => {
        return v !== upload;
      });
    },
    scrollToSave() {
      setTimeout(
        function () {
          this.$vuetify.goTo("#save-btn", {
            duration: 300,
            offset: 0,
            easing: "easeInOutCubic",
          });
        }.bind(this),
        100
      );
    },
    scrollToStatus() {
      setTimeout(
        function () {
          this.$vuetify.goTo("#project-status", {
            duration: 300,
            offset: 100,
            easing: "easeInOutCubic",
          });
        }.bind(this),
        100
      );
    },
    scrollToError() {
      setTimeout(
        function () {
          this.$vuetify.goTo("#error", {
            duration: 300,
            offset: 0,
            easing: "easeInOutCubic",
          });
        }.bind(this),
        100
      );
    },
  },
  mounted() {},
  async beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.loadProject();
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.loadProject();
    next();
  },
};
</script>
<style lang="scss" scoped>
</style>
